<template>
    <div>
        <section id="hero">
            <div>
                <div :class="['owl-carousel', 'owl-theme']" id="owl_main">
                    <div v-for="(val, key) in Slider_principal" :key="key" :class="[]" >
                        <div class="item">
                            <div class="car-container">
                                <img :src="val.path_file_imagen" alt="" style="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <main id="main">
            <section id="services" :class="['pb-1', 'mb-1']" style="padding: 4px 10px 20px;">
                <div :class="['container']">
                    <div :class="['section-title', 'card', 'text_color_drasam', 'mb-3']" style="background: #fafafa;margin-bottom: 4px; padding-bottom: 10px;">
                        <h2 :class="['']" style="margin-bottom: -2px;">{{empresa.razon_social}}</h2>
                        <h1 style="font-size:22px;"><p class="text-center">"{{globales.name_year}}"</p></h1>
                    </div>

                    <div :class="['row']">
                        <div :class="['col-lg-9', 'col-md-8', 'icon-box', 'mb-3']">
                            <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                                <div :class="['card-body', 'pt-2']">
                                    <h5 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-1']">Nuestros Proyectos</h5>

                                    <hr :class="['mt-1', 'mb-3']">
                                    <div :class="['owl-carousel', 'owl-theme']" id="owl_project">
                                        <div v-for="(val, key) in Slider_proyecto" :key="key" :class="[]" >
                                            <div class="item">
                                                <div class="car-container">
                                                    <img :src="val.path_baner_imagen" alt="" style="">
                                                    <div class="title">
                                                        <a href="javascript:void(0)">{{val.titulo}}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div :class="['col-lg-3', 'col-md-4', 'icon-box', 'mb-3']">
                            <div :class="['card', 'box', 'orden', 'borderTopCard', 'shadow-sm']">
                                <div :class="['card', 'box', 'orden', 'borderTopCard', 'shadow-sm', 'mb-3']">
                                    <div :class="['box-header', 'with-border']">
                                        <h5 :class="['box-title', 'pt-2', 'pb-0', 'mb-0', 'bolder', 'text-center']" >MESA VIRTUAL</h5>
                                    </div>

                                    <hr :class="['mb-1', 'mt-1']">
                                    <div :class="['box-body']" style=" ">
                                        <div :class="['list-group', 'pb-1']">
                                            <a href="https://mesavirtual.regionsanmartin.gob.pe" target="_blank">
                                                <img src="/img/mesa_virtual.jpg" style="width:100%;" :class="['img-thumbnail']">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div :class="['card', 'box', 'orden', 'borderTopCard', 'shadow-sm']">
                                <div :class="['box-header', 'with-border']">
                                    <h5 :class="['box-title', 'pt-2', 'pb-0', 'mb-0', 'bolder', 'text-center']" > DENUNCIAS</h5>
                                </div>
                                
                                <hr :class="['mb-1', 'mt-1']">
                                <div :class="['box-body']" style=" ">
                                    <div :class="['list-group', 'pb-1']">
                                        <a href="https://denuncias.servicios.gob.pe/?gobpe_id=2930" target="_blank" :class="['list-group-item', 'list-group-item-action', 'pt-1', 'text-justify', 'pb-1', 'text_color_drasam']" >
                                            <img src="/img/denunciar-corrupcion.png" style="width:100%;" :class="['img-thumbnail']">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Transparencia -->
            <section id="about" :class="['pt-2', 'pb-3', 'mb-1']" style="padding: 4px 10px 20px;">
                <div :class="['container']">
                    <div :class="['row']">
                        <div :class="['col-lg-9', 'col-md-8', 'mb-3']">
                            <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                                <div :class="['card-body', 'pt-2']">
                                    <h5 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-1']">TRANSPARENCIA Y ACCESO A LA INFORMACION PÚBLICA</h5>
                                    <hr :class="['mt-1', 'mb-3']"> 	
                                    <div :class="['row']">
                                        <div v-for="(val, key) in Transparencia" :key="key" :class="['col-lg-4', 'col-md-6', 'col-12', 'mb-2']">
                                            <a :href="val.url" :class="['text-secondary']" :alt="val.titulo" :title="val.titulo" target="_blank">
                                                <div :class="['card', 'shadow-sm']"  >						   
                                                    <div :class="['card-body', 'text-center', 'pb-0', 'pt-1']">
                                                        <img :src="val.icono" :class="['']" style="width:52%"/>
                                                        <h5 :class="['card-title', 'font-weight-bold', 'text_width']">{{val.titulo}}</h5>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div :class="['col-lg-3', 'col-md-4', 'icon-box', 'mb-3']">
                            <div :class="['card', 'box', 'orden', 'borderTopCard', 'shadow-sm', 'mb-3']">
                                <div :class="['box-header', 'with-border']">
                                    <h5 :class="['box-title', 'pt-2', 'pb-0', 'mb-0', 'bolder', 'text-center']" >LIBRO DE RECLAMACION</h5>
                                </div>

                                <hr :class="['mb-1', 'mt-1']">
                                <div :class="['box-body']" style=" ">
                                    <div :class="['list-group', 'pb-1']">
                                        <!--<router-link :class="['']" target="_blank" to="/LibroReclamacionVirtual/">-->
                                        <a target="_blank" href="https://reclamos.servicios.gob.pe/?institution_id=81">
                                            <img src="/img/libro_reclamaciones.jpg" style="width:100%;" :class="['img-thumbnail']">
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div :class="['card', 'box', 'orden', 'borderTopCard', 'shadow-sm']">
                                <div :class="['box-header', 'with-border']">
                                    <h5 :class="['box-title', 'pt-2', 'pb-0', 'mb-0', 'bolder', 'text-center']" > DOCUMENTOS</h5>
                                </div>

                                <hr :class="['mb-1', 'mt-1']">
                                <div :class="['box-body']" style=" ">
                                    <div :class="['list-group', 'pb-1']">
                                        <router-link to="/convocatorias_nombramiento" :class="['list-group-item', 'list-group-item-action', 'bordeZero', 'pt-1', 'pb-1', 'text_color_drasam']" >
                                            <i :class="['icofont-archive']"></i> Conv. Nombram. 276 
                                            
                                            <span v-if="notificacionConvNomb>0" :class="['bell', 'badge', 'badge-light', 'ml-0', 'colorRedBell', 'fuente10']" style="width: 15px; height:15px; display:inline-block;">
                                                {{notificacionConvNomb}}
                                            </span>
                                        </router-link>

                                        <router-link to="/convenios" :class="['list-group-item', 'list-group-item-action', 'bordeZero', 'pt-1', 'pb-1', 'text_color_drasam']" >
                                            <i class="icofont-archive"></i> Convenios 

                                            <span v-if="notificacionConvenio>0" :class="['bell', 'badge', 'badge-light', 'ml-0', 'colorRedBell', 'fuente10']" style="width: 15px; height:15px; display:inline-block;">
                                                {{notificacionConvenio}}
                                            </span>
                                        </router-link>

                                        <a href="https://www.gob.pe/institucion/regionsanmartin-dra/informes-publicaciones/tipos/27-documento-de-gestion" target="_blank" :class="['list-group-item', 'list-group-item-action', 'bordeZero', 'pt-1', 'pb-1', 'text_color_drasam']" >
                                            <i class="icofont-archive"></i> Documentos Gesti&oacute;n
                                        </a>
                                        <a href="https://www.gob.pe/institucion/regionsanmartin-dra/normas-legales" target="_blank" :class="['list-group-item', 'list-group-item-action', 'bordeZero', 'pt-1', 'pb-1', 'text_color_drasam']" >
                                            <i class="icofont-archive"></i> Resoluciones

                                            <span v-if="notificacionResolucion>0" :class="['bell', 'badge', 'badge-light', 'ml-0', 'colorRedBell', 'fuente10']" style="width: 15px; height:15px; display:inline-block;">
                                                {{notificacionResolucion}}
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="about" :class="['pt-2', 'pb-2', 'mb-1']" style="padding: 4px 10px 20px;">
                <div :class="['container']">
                    <div :class="['row']">
                        <div :class="['col-lg-9', 'col-md-8', 'mb-1']">
                            <div :class="['card', 'borderTopCard', 'shadow-sm']" >
			                    <div :class="['card-body', 'pt-2']">
                                    <h5 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-1']">Videos	</h5>
                                    <hr :class="['mt-1', 'mb-3']"> 	
			                        <div :class="['row']">
                                        <div v-for="(val, key) in Videos" :key="key" :class="['col-lg-6', 'col-md-6', 'mb-2']">
                                            <a href="" :class="['text-secondary']">
                                                <div :class="['card', 'p-0']"  >
                                                    <div :class="['card-body', 'text-center', 'p-0']">
                                                        <iframe width="100%" height="280" :src="val.url" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div :class="['col-lg-3', 'col-md-4', 'icon-box', 'mb-1']">
                            <div :class="['card', 'box', 'orden', 'borderTopCard', 'shadow-sm']">
                                <div :class="['box-header', 'with-border']">
                                    <h5 :class="['box-title', 'pt-2', 'pb-0', 'mb-0', 'bolder', 'text-center']" > Servicios y Recursos</h5>
                                </div>
                                <hr :class="['mb-1', 'mt-1']">
                                <div :class="['box-body']" style=" ">
                                    <div :class="['list-group', 'pb-1']">
                                        <router-link to="/precios_productos" :class="['list-group-item', 'list-group-item-action', 'bordeZero', 'pt-1', 'pb-1', 'text_color_drasam']" >
                                            <i :class="['icofont-archive']"></i>
                                            Precios de productos agr&iacute;colas 
                                            <span v-if="notificacionPrecio_producto>0" :class="['bell', 'badge', 'badge-light', 'ml-0', 'colorRedBell', 'fuente10']" style="width: 15px; height:15px; display:inline-block;">
                                                {{notificacionPrecio_producto}}
                                            </span>
                                        </router-link>

                                        <a v-for="(val, key) in Servicios" :key="key" :href="val.url" target="_blank" :class="['list-group-item', 'list-group-item-action', 'bordeZero', 'pt-1', 'pb-1', 'text_color_drasam']" >
                                            <i :class="['fa', val.icono, 'fa-1x']"></i> {{val.titulo}}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <!-- ======= About Lists Section ======= -->
            <section :class="['about-lists']">
                <div :class="['container']">
                    <div :class="['row', 'no-gutters']">
                        <div :class="['col-lg-12']">
                            <div :class="['owl-carousel', 'owl-theme']" id="carrouselInstituciones">
                                <div v-for="(val, key) in Enlaces_externos" :key="key" :class="['item', 'hvrbox']">
                                    <img :src="val.path_file_imagen" :alt="val.titulo_enlace" style="width: 125px; height:55px;" :class="['hvrbox-layer_bottom']" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <!-- MODAL SLIDER FLOTANTE -->
        <Modal ref="form_emergente" dialog="modal-xl">
			<template slot="title"></template>
			<form :class="['modal-body', 'needs-validation', 'was-validated']" novalidate>
				<div :class="['']">
					<div :class="['row']">
						<div :class="['col-lg-12', 'col-12', 'form-group']">
                            <div :class="['owl-carousel', 'owl-theme']" id="owl_flotante">
                                <div v-for="(val, key) in Slider_flotante" :key="key" :class="[]" >
                                    <div class="item">
                                        <div class="car-container">
                                            <img :src="val.path_file_imagen" alt="" class="img-responsive">
                                            <div v-if="val.titulo" class="title">{{val.titulo}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>
				</div>
			</form>

			<template slot="footer">
				<button type="button" :class="['btn', 'btn-primary', 'w-auto', 'mr-2', 'h-auto', 'waves-effect', 'waves-themed']" @click="cerrarModal">
					<i class="icofont-ui-close" ></i> Cerrar
				</button>
			</template>
		</Modal>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import Modal from '@/components/Modal.vue';
    export default {
        name: 'Web',
        computed:{
            ...mapState(['loading','globales','empresa', 'notificaciones']),
        },
        components: {
			Modal,
		},
        mounted(){
            this.loadObjEmpresa();
            this.loadObjNotificacion();
            this.getPrincipal();
            document.title = "Bienvenido a la "+((this.empresa.abreviatura)?this.empresa.abreviatura:"DRASAM");

            this.notificacionNoticia            = parseInt(this.notificaciones['NOTICIA']['cant']??0);
            this.notificacionPrecio_producto    = parseInt(this.notificaciones['PRECIO_PRODUCTO']['cant']??0);
            this.notificacionComplementarios    = parseInt(this.notificaciones['COMPLEMENTARIOS']['cant']??0);
            this.notificacionBolsa_producto     = parseInt(this.notificaciones['BOLSA_PRODUCTO']['cant']??0);
            this.notificacionCosto_produccion   = parseInt(this.notificaciones['COSTO_PRODUCCION']['cant']??0);
            this.notificacionReporte_plagas     = parseInt(this.notificaciones['REPORTE_PLAGAS']['cant']??0);
            this.notificacionConvenio           = parseInt(this.notificaciones['CONVENIO']['cant']??0);
            this.notificacionResolucion         = parseInt(this.notificaciones['RESOLUCION']['cant']??0);
            this.notificacionConvocatoria       = parseInt(this.notificaciones['CONVOCATORIA']['cant']??0);
            this.notificacionDocumento_gestion  = parseInt(this.notificaciones['DOCUMENTO_GESTION']['cant']??0);
            this.notificacionSci                = parseInt(this.notificaciones['SCI']['cant']??0);
            this.notificacionAgricola_pecuaria  = parseInt(this.notificaciones['AGRICOLA_PECUARIA']['cant']??0);
            this.notificacionConvNomb           = parseInt(this.notificaciones['CONV_NOMBRAMIENTO']['cant']??0);
        },
        data(){
            return{
                Slider_principal: [],
                Slider_proyecto:[],
                Slider_flotante:[],
                Noticias:[],
                Enlaces_externos:[],
                Clima:{
                    name:"San Martin",
                    region:"San Martin",
                    country:"Perú",
                    fecha_registro:"",
                    temperature:"0",//
                    uv_index:"0",//
                    precip:"0",
                    pressure:"0",
                },
                Path_file_mesa_virtual:"",
                Path_file_libro_reclamo:"",
                Transparencia:[],
                Videos:[],
                Servicios:[],

                notificacionNoticia:0,
                notificacionPrecio_producto:0,
                notificacionComplementarios:0,
                notificacionBolsa_producto:0,
                notificacionCosto_produccion:0,
                notificacionReporte_plagas:0,
                notificacionConvenio:0,
                notificacionResolucion:0,
                notificacionConvocatoria:0,
                notificacionDocumento_gestion:0,
                notificacionSci:0,
                notificacionAgricola_pecuaria:0,
                notificacionConvNomb:0,
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa', 'loadObjNotificacion']),
            getPrincipal(){
                var selfs = this;
                selfs.setLoading(true);
                
                this.$http.get('webserviceserver/principal').then((res)=>{
                    if(res.data.Slider_main)
                        selfs.Slider_principal       = res.data.Slider_main;
                    if(res.data.Slider_project)
                        selfs.Slider_proyecto        = res.data.Slider_project;
                    if(res.data.Slider_flotant)
                        selfs.Slider_flotante        = res.data.Slider_flotant;
                    if(res.data.News)
                        selfs.Noticias               = res.data.News;
                    if(res.data.External_link)
                       selfs.Enlaces_externos        = res.data.External_link;
                    if(res.data.Path_mesa_virtual)
                        selfs.Path_file_mesa_virtual = res.data.Path_mesa_virtual;
                    selfs.Path_file_libro_reclamo= res.data.Path_libro_reclamo;
                    selfs.Transparencia          = res.data.Transparency;
                    selfs.Videos                 = res.data.Videos;
                    if(res.data.Services)
                        selfs.Servicios              = res.data.Services;
                    
                    if(res.data.Climate)
                        selfs.Clima              = res.data.Climate;

                    if(this.Slider_flotante.length>0){
                        this.$refs.form_emergente.open();
                    }
                    setTimeout(()=>{
                        this.setLoading(true);
                        this.owlCarousel();
                        setTimeout(()=>{
                            this.setLoading(false);
                        }, 500);
                    },200);
                }).finally(()=>{
                    //this.setLoading(false);
                });
            },
            owlCarousel(){
                $('#noticiasOwl').owlCarousel({
                    loop:false,
                    margin:3,
                    nav:true,
                    autoplay:false,
                    autoplayTimeout:2000000,
                    autoplayHoverPause:true,
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:2
                        },
                        1000:{
                            items:3
                        }
                    }
                });

                $('#carrouselInstituciones').owlCarousel({
                    loop:true,
                    margin:3,
                    nav:true,
                    autoplay:true,
                    autoplayTimeout:2000,
                    autoplayHoverPause:true,
                    items:6,  		 
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:2
                        },
                        1000:{
                            items:6
                        }
                    }
                });

                $("#owl_main").owlCarousel({
                    items: 1,
                    margin:0,
                    autoplay: true,
                    dots: false,
                    loop: true,
                    autoplayTimeout:5000,
                    responsive: {0: {items: 1}, 768: {items: 1}, 900: {items: 1},
                    },
                    nav: true,
                    navText: ["<i class='fa fa-chevron-left fa-2x' aria-hidden='true'></i>","<i class='fa fa-chevron-right fa-2x' aria-hidden='true'></i>"],
                });

                $("#owl_project").owlCarousel({
                    items: 1,
                    margin:0,
                    autoplay: false,
                    dots: false,
                    loop: true,
                    responsive: {0: {items: 1}, 768: {items: 1}, 900: {items: 1},
                    },
                    nav: true,
                    navText: ["<i class='fa fa-chevron-left fa-2x' aria-hidden='true'></i>","<i class='fa fa-chevron-right fa-2x' aria-hidden='true'></i>"],
                });

                $("#owl_flotante").owlCarousel({
                    items: 1,
                    margin:0,
                    autoplay: true,
                    dots: false,
                    loop: true,
                    autoplayTimeout:5000,
                    responsive: {0: {items: 1}, 768: {items: 1}, 900: {items: 1},
                    },
                    nav: true,
                });
            },
            cerrarModal(){
                var selfs = this;
				selfs.$refs.form_emergente.close();
            },
        },
    }
</script>

<style scoped>
    .bg-gris {
        border: 0px solid #F1F1F1;
        padding: .8rem;
        border-radius: 15px;
        margin: 0.8rem 0;
    }

    .box-temp-actu h4{
        font-size: 3.6rem !important;
        font-weight: 100 !important;
    }

    .text-max {
        color: #000;
    }

    .text-temp-detalle {
        font-size: 26px;
        font-weight: 700;
    }

    .text-min {
        color: #BCBCBC;
    }

    .box-temp-actu .grad {
        font-size: 2rem;
        font-weight: 100;
        vertical-align: top;
        padding-top: 5px;
    }

    .box-temp-actu span {
        
    }

    .box-temp-actu .cent, .box-temp-actu .fare {
        font-size: 1.9rem;
        font-weight: 100;
        line-height: 42px;
    }
    .box-temp-actu span.icon-temp {
        text-align: center;
        font-size: 1.20rem;
        color: #FF975C;
    }
</style>